export const WEBSITE_URL: string = 'https://www.v-comply.com/'
